<template>
  <router-view style="height:100%;" :style="{background:this.$store.state.pageBackground}"></router-view>
</template>

<script>
export default {
  mounted: function() {
    //
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 270);
    }
  }
};
</script>
<style lang="sass">
@import '~vue-xpc/src/style/index.scss';   
</style>



// WEBPACK FOOTER //
// App.vue?1e5b6b1f